'use client';

import { useEffect } from 'react';
import confetti from 'canvas-confetti';
import { useGameStore } from '@/store/useGameStore';

export function LevelUpModal() {
  const levelUpPending = useGameStore((s) => s.levelUpPending);
  const previousLevel = useGameStore((s) => s.previousLevel);
  const level = useGameStore((s) => s.level);
  const levelName = useGameStore((s) => s.levelName);
  const dismiss = useGameStore((s) => s.dismissLevelUp);

  useEffect(() => {
    if (!levelUpPending) return;

    // Fire confetti
    const fire = (angle: number, origin: number) => {
      confetti({
        angle,
        spread: 60,
        particleCount: 80,
        origin: { x: origin, y: 0.6 },
        colors: ['#5B4FE8', '#00C9A7', '#F59E0B', '#FF6B6B'],
      });
    };
    fire(60, 0);
    fire(120, 1);

    // Auto-dismiss after 7s
    const timer = setTimeout(dismiss, 7000);
    return () => clearTimeout(timer);
  }, [levelUpPending, dismiss]);

  if (!levelUpPending) return null;

  return (
    <div
      className="fixed inset-0 z-[10001] flex items-center justify-center p-4"
      style={{ background: 'rgba(8,8,16,0.92)', backdropFilter: 'blur(12px)' }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="levelup-title"
    >
      <div className="text-center max-w-sm w-full animate-bounce-once">
        <p
          className="font-display font-black tracking-wider mb-4"
          style={{ fontSize: '64px', lineHeight: 1 }}
        >
          <span className="gradient-text">LEVEL UP!</span>
        </p>

        <div className="flex items-center justify-center gap-4 mb-4">
          <span
            className="text-5xl font-bold opacity-60"
            style={{ color: 'var(--color-text-secondary)', fontFamily: 'var(--font-display)' }}
          >
            {previousLevel}
          </span>
          <span className="text-2xl" aria-hidden="true">→</span>
          <span
            className="text-6xl font-black gradient-text"
            style={{ fontFamily: 'var(--font-display)' }}
          >
            {level}
          </span>
        </div>

        <p
          className="text-xl font-semibold mb-8"
          style={{ color: '#00C9A7', fontFamily: 'var(--font-display)' }}
        >
          {levelName}
        </p>

        <button
          onClick={dismiss}
          className="btn-primary text-base px-8 py-3"
        >
          Continue →
        </button>
      </div>
    </div>
  );
}
